/**
 * @author: @augustomna2010
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.TimeMinutesField = (function () {

    function TimeMinutesField () {

        Monet.UI.Fields.TimeField.apply(this, arguments);

        this.getValue = function () {

            if(this.input.value === "") {
                return "";
            }
            var seconds = new Monet.Format.SECONDS(this.input.value).convertHourToSeconds().getValue();
            return seconds / 60;

        };

        this.setInputValue = function () {

            if (this.input && this.value) {
                this.input.value = this.value;
            }
        };


        this.setValue = function (value) {
            if (value) {

                this.value = new Monet.Format.SECONDS(value * 60).convertSecondsToHourMinutes().getValue();
                this.setInputValue();

            }
        };

        this.initializeSpecialBehavior = function () {

            new Monet.Date.GeneralFunctions().setTimePicker(this.input, null, 'HH:mm');
        };

    }

    return TimeMinutesField;

}());
